module.exports = __webpack_public_path__ + "static/media/icon-Visa.924915de.png";